<template>
  <div>
    <b-row class="mx-0">
      <b-col style="flex: 0 0 50px" class="pl-0">
        <div class="title-badge-icon" :class="'bg-' + type.toLowerCase()">
          <font-awesome-icon v-if="type == 'Client'" :icon="['fas', 'industry-alt']" size="2x" />
          <font-awesome-icon v-if="type == 'Project'" :icon="['fas', 'briefcase']" size="2x" />
          <font-awesome-icon v-if="type == 'Access'" :icon="['fas', 'warehouse']" size="2x" />
          <font-awesome-icon v-if="type == 'Employee'" :icon="['fas', 'user-tie']" size="2x" />
          <font-awesome-icon v-if="type == 'Bundle'" :icon="['fas', 'boxes-alt']" size="2x" />
          <img v-if="type == 'Anden'" :src="andenImg" alt="Anden" />
          <img v-if="type == 'Puerta'" :src="puertaImg" alt="Puerta" />
          <img v-if="type == 'ControlAcceso'" :src="controlAccesoImg" alt="CA" />
          <font-awesome-icon v-if="type == 'Generico'" :icon="['far', 'globe']" size="2x" />
        </div>
      </b-col>
      <b-col class="pl-5">
        <b-row align-h="between" class="title-badge-text-top pr-2">
          <span style="color: #6c757d;">{{ typeString }}</span>
          <span style="letter-spacing: 2px">
            <slot name="id"></slot>
            {{ id }}
          </span>
        </b-row>
        <b-row class="title-badge-text-bottom">
          <div style="word-wrap: break-word">
            <slot name="title"></slot>
            {{ title }}
          </div>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AndenImage from 'images/anden.webp'
import PuertaImage from 'images/puerta_automatica.webp'
import ControlAccesoImage from 'images/access_control.webp'

export default {
  name: 'TitleBadge',
  props: {
    id: String,
    type: String,
    title: String
  },
  computed: {
    typeString() {
      if (this.type == 'Client') {
        return this.id
      } else if (this.type == 'Project') {
        return 'Proyecto'
      } else if (this.type == 'Access') {
        return 'Acceso'
      } else if (this.type == 'Employee') {
        return 'Empleado'
      } else if (this.type == 'Bundle') {
        return 'Bulto'
      } else if (this.type == 'Anden') {
        return 'Andén'
      } else if (this.type == 'ControlAcceso') {
        return 'Control de Acceso'
      } else if (this.type == 'Generico') {
        return 'Genérico'
      }

      return this.type
    },
    andenImg () {
      return AndenImage
    },
    puertaImg () {
      return PuertaImage
    },
    controlAccesoImg () {
      return ControlAccesoImage
    }
  }
}
</script>

<style scoped>
.title-badge-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: #163D7D;
  border-radius: 5px;
  width: 50px;
  height: 50px;
}
.title-badge-icon.bg-client {
  background-color: rgb(121, 100, 101);
}
.title-badge-icon.bg-project {
  background-color: #163D7D;
}
.title-badge-icon.bg-access {
  background-color: #ff9900;
}
.title-badge-icon.bg-employee {
  background-color: #333;
}
.title-badge-icon.bg-bundle {
  background-color: #333;
}
.title-badge-icon.bg-anden {
  background-color: #163D7D;
}
.title-badge-icon.bg-anden img {
  filter: brightness(0) invert(1);
  width: 81px;
}

.title-badge-icon.bg-puerta {
  background-color: #163D7D;
}
.title-badge-icon.bg-puerta img {
  filter: brightness(0) invert(1);
  width: 81px;
}

.title-badge-icon.bg-controlacceso {
  background-color: #163D7D;
}
.title-badge-icon.bg-controlacceso img {
  filter: brightness(0) invert(1);
  width: 52px;
}
.title-badge-text-top {
  text-transform: uppercase;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  margin-bottom: 0;
}
.title-badge-text-bottom {
  font-family: 'Lato', sans-serif;
  font-size: 20px;
  margin-bottom: 0;
}
</style>
